export default "__VITE_ASSET__BjSjZJ7Y__"